(function () {
  'use strict';

  /* @ngdoc object
   * @name api
   * @description
   *
   */
  angular
    .module('itecAdministracio.api', [
      'ui.router',
      'itecAdministracio.api.persona',
      'itecAdministracio.api.usuari',
      'itecAdministracio.api.entitat',
      'itecAdministracio.api.llicencia',
      'itecAdministracio.api.producte',
	    'itecAdministracio.api.rol',
      'itecAdministracio.api.logo',
      'itecAdministracio.api.productebotiga',
      'itecAdministracio.api.tema',
      'itecAdministracio.api.logout',
      'itecAdministracio.api.aplicacio',
      'itecAdministracio.api.tyk'
    ]);
}());
